module.exports = __webpack_public_path__ + "static/media/vale.782dda05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/vale.png
// module id = 1160
// module chunks = 0